import AuthService from "@/services/api/auth/auth";
import React, { useEffect, useMemo, useState } from 'react'
import { useForm } from "react-hook-form";
import toast from "@/lib/toast";
import MapView from "@/components/Map/MapView";
import { useDrawer } from '@/components/Drawer/context/DrawerContext';
import Modal from '@/components/Modal/Modal';
import { IconButton, Typography } from '@mui/material';
import Table from '@/components/Table/Table'
import RetailerDetailsDrawer from "./RetailerDetailsDrawer/RetailerDetailsDrawer";
import Filter from "@/components/FilterComponent/Filter";
import CustomHeader from "@/components/CustomHeader/CustomHeader";
import { useSearchPagination } from "@/hooks/useSearchPagination";
import Pagination from "@/components/Table/Pagination";
import { renderStatus } from "../Order/component/OrderColumn";
import AppliedFilter from "@/components/FilterComponent/AppliedFilter";
import { retailerStatusList } from "@/lib/utils";
import { Visibility } from "@mui/icons-material";
import RejectedReasonModal from "./retailerRejectedReason";
interface RetilerRow {
    RetailerShopName: string;
    PersonName: string;
    Designation: string;
    Email: string;
    PhoneNumber: string;
    Action: string;
}

const RetailerRequest: React.FC = () => {
    const { openDrawer } = useDrawer();
    const [page, setPage] = React.useState(0);
    const [loading, setLoading] = useState(true);
    const [states, setStates] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [Localities, setLocalities] = useState<any[]>([]);
    const [attendanceData, setAttendanceData] = useState<RetilerRow[]>([]);
    const [mapModalOpen, setMapModalOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState("");
    const [mapLocation, setMapLocation] = useState({ lat: 18.96905, lng: 72.82118 });
    const [countries, setCountries] = useState<any[]>([]);
    const [searchText, setSearchText] = useState<any>("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [RejectModal, setRejectModal] = useState(false)
    const [rejectReason, setRejectReason] = useState("");
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [filters, setFilters] = useState<{ status?: string }>({});
    const [totalRecords, setTotalRecords] = useState<any>(null);
    const [reasonModalOpen, setReasonModalOpen] = useState(false);
    const [selectedRetailer, setSelectedRetailer] = useState<any>(null);

    const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const columns = useMemo(
        () => [
            // {name:"id",selector:(row:any)=>row.id},
            { name: "Retailer Name", selector: (row: any) => <span className="cursor-pointer text-blue-400" 
            onClick={() => openDrawer(<RetailerDetailsDrawer retailerId={row.id} />)}>{row.name}</span> },
            { name: "Person Name", selector: (row: any) => row.contactName },
            { name: "Designation", selector: (row: any) => row.designation },
            { name: "Email", selector: (row: any) => row.emailId },
            { name: "Phone Number", selector: (row: any) => row.mobileNumber },
            {
                name: "Status",
                selector: (row: any) =>  renderStatus(row.status)
            },
            {
                name: "Action",
                selector: (row: any) => (
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        {row.status === "Pending" ? (
                            <>
                                <button
                                    style={{
                                        background: "#6570FC",
                                        cursor: "pointer",
                                        borderRadius: "6px",
                                        width: "67px",
                                        height: "32px",
                                        fontWeight: '600',
                                        color: 'white',
                                        fontSize: "0.75rem",
                                    }}
                                    onClick={() => StatusCheck("ACCEPT", row)}
                                >
                                    Accept
                                </button>
            
                                <button
                                    style={{
                                        background: "#FFFFFF",
                                        cursor: "pointer",
                                        borderRadius: "6px",
                                        width: "67px",
                                        height: "32px",
                                        border: "1px solid #6570FC",
                                        fontWeight: '600',
                                        color: "#6570FC",
                                        fontSize: "0.75rem",
                                    }}
                                    onClick={() => StatusCheck("REJECT", row)}
                                >
                                    Reject
                                </button>
                            </>
                        ) : row.status === "Reject" ? (
                            <div>
                                    <IconButton onClick={() => {
                                        setSelectedRetailer(row);
                                        setReasonModalOpen(true);
                                    }}>
                                    <Visibility />
                                </IconButton>
                            </div>
                        ) : ""}
                    </div>
                )
            }
            
        ], []
    )

    const {
        pageSelected,
        setPageSelected,
        rowsPerPageValue,
        setRowsPerPageValue,
    } = useSearchPagination();


    const StatusCheck = async (action: "ACCEPT" | "REJECT", row: any, reason?: string) => {
        if (action === "REJECT" && !reason) {
            setSelectedRow(row);
            setRejectModal(true);
            return;
        }

        const payload = {
            id: row.id,
            reason: action === "REJECT" ? reason : "",
            isApproved: action === "ACCEPT" ? true : false
        };

        try {
            const res = await AuthService.RetailerStatus(payload);
            if (res?.status === 200) {
                toast.success(action === "ACCEPT" ? "Retailer Approved" : "Retailer Rejected");
                setRejectReason("")
                setRejectModal(false);
                fetchRetiler();
            }
        } catch (err) {
            toast.error("Something went wrong!");
        }
    }

    useEffect(() => {
       const timer = setTimeout(() => {
         fetchRetiler(searchText);
       }, 1000);
   
       return () => clearTimeout(timer);
    }, [pageSelected, searchText,filters]);

    const from = (pageSelected - 1) * rowsPerPageValue + 1;
    const to = pageSelected * rowsPerPageValue;

    const fetchRetiler = async (query = "") => {
        try {
            const data = {
                from,
                to,
                searchName: query,
                status: filters.status || ""
            }

            const res = await AuthService.GetRetailerList(data)
            setTotalRecords(res?.data?.totalRecords);
            setAttendanceData(
                res?.data?.items.map((item: any) => ({
                    id: item.id,
                    name: item.name,
                    contactName: item.contactName,
                    designation: item.designation,
                    emailId: item.emailId,
                    mobileNumber: item.mobileNumber,
                    address: item.address,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    cityName: item.cityName,
                    stateName: item.stateName,
                    countryName: item.countryName,
                    pincode: item.pincode,
                    contactNo: item.contactNo,
                    contactEmail: item.contactEmail,
                    rejectedReason: item.rejectedReason,
                    status:item.status
                }))
            );
        } catch (err: any) {
            toast.error("Failed to load retailer");
        } finally {
            setLoading(false)
        }
    }

    const { handleSubmit, watch, setValue } = useForm({
        mode: "onTouched"
    })

    const selectedCountryId = watch("countryId")?.value;
    const selectedStateId = watch("State");
    const selectedCityId = watch("City")

    useEffect(() => {
        const loadCountries = async () => {
            try {
                const countriesData = await AuthService.getCountries();
                const newCountries = countriesData.map((obj) => ({
                    value: obj.countryId,
                    label: `${obj.countryCode} ${obj.name}`,
                }));
                setCountries(newCountries);
            } catch (err: any) {
                toast.error("Failed to load countries, please try again.");
            }
        };

        loadCountries();
    }, []);

    useEffect(() => {
        if (!selectedCountryId) return;
        const loadStates = async () => {
            try {
                const stateData = await AuthService.GetState(selectedCountryId);
                const newStates = stateData.map((s: any) => ({
                    value: s.stateId,
                    label: s.name,
                }));
                setValue("State", null);
                setValue("City", null);
                setStates(newStates);
                setCities([]);
            } catch (err: any) {
                toast.error("Failed to load states");
            }
        };
        loadStates();
    }, [selectedCountryId, setValue])

    useEffect(() => {
        if (!selectedStateId) return;

        const loadCities = async () => {
            try {
                const cityData = await AuthService.GetCity(selectedStateId);
                const newCities = cityData.map((c: any) => ({
                    value: c.cityId,
                    label: c.name,
                }));
                setCities(newCities);
            } catch (err: any) {
                toast.error("Failed to load cities");
            }
        };
        loadCities();
    }, [selectedStateId]);

    // useEffect(() => {
    //     if (!selectedCityId) return

    //     const loadLocality = async () => {
    //         try {
    //             const LocalityData = await AuthService.GetLocality(selectedCityId);
    //             const newLocalities = LocalityData.map((c: any) => ({
    //                 value: c.CityId,
    //                 label: c.Name,
    //             }));
    //             setLocalities(newLocalities)
    //         } catch (err: any) {
    //             toast.error("Failed to load localities");
    //         }
    //     }
    //     loadLocality();
    // }, [selectedCityId, setValue])

    const handleSave = () => {
        setMapModalOpen(false);
    };

    const handleSelectLocation = (lat: number, lng: number, addr: string) => {
        setMapLocation({ lat, lng });
        setSelectedAddress(addr);
        setValue("Address", addr);
        setValue("latitude", lat);
        setValue("longitude", lng);
    };
    
    const handleDeleteConfirm = async (selectedRow: any) => {
        setDeleteModalOpen(false);
        const res = await AuthService.DeleteRetailer(selectedRow)
    };

    const handleModalClose = () => {
        setRejectModal(false);
        setRejectReason("");
    }

    return (
        <div className="p-5">
            
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
                <div className="flex items-center justify-between w-full">

                    <h2 className="text-2xl md:text-lg font-semibold whitespace-nowrap">
                        Retailer Request
                    </h2>

                    <Filter
                        anchorEl={anchorEl}
                        onClick={handleFilterClick}
                        onClose={handleClose}
                        onApply={(appliedFilters) => {
                            setFilters({
                                status: appliedFilters.status || "",
                            });
                            setPageSelected(1);
                        }}
                        appliedFilter={filters}
                        list={{ statusList: retailerStatusList }}
                        showFilter={{ status: true }}
                    />
                </div>
                <div className="flex gap-2 w-full md:w-auto md:items-center">
                    <CustomHeader
                        filter={false}
                        search={searchText}
                        setSearch={setSearchText}
                    ></CustomHeader>
                </div>
            </div>
            
            {/* Show Applied Filter */}
            <AppliedFilter filterData={filters} onClearFilter={setFilters} />

            <Table
                columns={columns} data={attendanceData ?? []}
            />

            <Pagination
                isPagination={true}
                totalCount={totalRecords ?? 0}
                pageSelected={pageSelected}
                setPageSelected={setPageSelected}
                rowsPerPageValue={rowsPerPageValue}
                setRowsPerPageValue={setRowsPerPageValue}
                customRowsPerPage={false}
            />

            <Modal
                modalOpen={mapModalOpen}
                closeModal={() => setMapModalOpen(false)}
                heading="Select Address on Map"
                width="800px"
                onSave={() => handleSave()}
            >
                <MapView
                    defaultLat={mapLocation.lat}
                    defaultLng={mapLocation.lng}
                    onSelectLocation={handleSelectLocation}
                    showSearchBar={true}
                />
            </Modal>

            {/* DELETE MODAL */}
            <Modal
                modalOpen={deleteModalOpen}
                closeModal={() => setDeleteModalOpen(false)}
                heading="Delete Retailer"
                width="400px"
                hideHeader={true}  
                hideFooter={true}
            >
                <div className="flex flex-col items-center text-center p-4">

                    <img src="/assets/media/delete-big.png" className="w-14 mb-3" />

                    <h2 className="text-lg font-semibold mb-2">Delete Retailer</h2>
                    <p className="text-gray-500 mb-6">
                        Are you sure you want to delete this Retailer?
                    </p>

                    <div className="flex gap-4 justify-center">
                        <button
                            className="px-6 py-2 border rounded-md"
                            onClick={() => setDeleteModalOpen(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="px-6 py-2 bg-red-500 text-white rounded-md"
                            onClick={() => handleDeleteConfirm(selectedRow?.id)}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </Modal>


            {/* accept reject */}
            <Modal

                modalOpen={RejectModal}
                closeModal={handleModalClose}
                heading={"Reason for Rejection"}
                saveButtonText={"Reject"}
                onSave={handleSubmit(()=>(StatusCheck("REJECT", selectedRow, rejectReason)))}
                width="500px"
            >
                <>
                    <Typography mb={1}>
                        Please provide reason for rejecting <strong>{selectedRow?.Name} <span style={{ color: "red" }}>*</span></strong>:
                    </Typography>

                    <textarea
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        placeholder="Enter reason..."
                        required
                        style={{
                            width: "100%",
                            minHeight: "80px",
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",

                        }}
                    />
                </>
            </Modal>
            <RejectedReasonModal
                open={reasonModalOpen}
                onClose={() => setReasonModalOpen(false)}
                reason={selectedRetailer}
            />
        </div>
    )
}

export default RetailerRequest;